export * from "./permissions/getters";

export const allAppsNumber = state => state.appsNumber;

export const noAppsToShow = state => !state.appsNumber; // || (state.pagedApps && state.pagedApps.length === 0);

export const apps = state => state.apps;

export const getStaticAppIdsList = state => state.staticAppIdsList;

export const hasMoreApps = state => state.hasMore;

export const pagedApps = state => state.pagedApps;

export const applicationTypeModels = state => state.applicationTypeModels;

export const currentApp = state => state.currentApp;

export const currentProcess = state => state.currentProcess;

export const processList = state => state.processList;

export const appDDL = state => state.appDDL;

export const path = state => state.path;

export const getCurrentNrOfApps = state => state.currentNrOfApps;

export const getAppWasArchived = state => state.appWasArchived;

export const getDiagramExternalPlugins = state => state.diagramExternalPluginList;
